( function () {
    'use strict';
    e.nav = {};
    e.nav.phone = function () {
        jQuery( document ).on( 'click', '.js-e-toggle-nav', function () {
            jQuery( 'body' ).toggleClass( 'e-nav-phone-open' );
        } );
    };
}() );